import { Typography } from "@mui/material";
import { ReactNode } from "react";
import { PopupMessage } from "../PopupMessage";
import { ContentStyle } from "./styled";

const Content = ({ children }: { children: ReactNode }) => {
  return (
    <Typography sx={ContentStyle}>
      {children}
    </Typography>
  );
}

export const BoardDisclaimer = ({ handleClick }: { handleClick: () => void }) => {
  return (
    <PopupMessage onClose={handleClick} >
      <Content>
        The Plugin, callback and Dispatch information is in real time.
      </Content>
      <Content>
        This information may change at anytime.
      </Content>
      <Content>
        Plugin, Callback, Dispatch and other information displayed here are provided for informational purposes only.
      </Content>
      <Content>
        The Dispatch Office and/or actual site personnel continue to be responsible for Plugin,
        Callback, Dispatch and related information.
      </Content>
    </PopupMessage>
  );
}